import React, { useContext, useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { FaPlusSquare, FaThList } from "react-icons/fa";
import ListGroup from "react-bootstrap/ListGroup";
import { Badge, Button, Col, Row } from "react-bootstrap";
import { getPoolsCurrentUser } from "../../http/poolAPI"; // Импорт метода API для получения опросов
import { useNavigate } from "react-router-dom";
import AllUserPolls from "../poolpages/AllUserPolls";

const ColPools = observer(({ onPoolSelect, setActiveComponent, onClose }) => {
    const { poolStore } = useContext(Context); // Контекст для работы с состоянием опросов
    const { user } = useContext(Context); // Контекст для пользователя
    const [hoveredItemId, setHoveredItemId] = useState(null);
    const [pollsLoaded, setPollsLoaded] = useState(false);
    const [pollsLoadError, setPollsLoadError] = useState("");
    const navigate = useNavigate();
    const demoPolls = [
        { id: 'demo-1', name: 'Demo Poll: Cover Battle', status: 'LIVE', isDemo: true },
        { id: 'demo-2', name: 'Demo Poll: Title Matchup', status: 'RUNNING', isDemo: true },
        { id: 'demo-3', name: 'Demo Poll: Blurb Check', status: 'COMPLETED', isDemo: true },
        { id: 'demo-4', name: 'Demo Poll: Cover & Title Test', status: 'LIVE', isDemo: true },
        { id: 'demo-5', name: 'Demo Poll: Description Appeal', status: 'COMPLETED', isDemo: true },
    ];

    useEffect(() => {
        if (user?.user?.id) {
            setPollsLoaded(false);
            setPollsLoadError("");
            poolStore.setCurrentUserPools([]);
            getPoolsCurrentUser(user.user.id)
                .then((data) => {
                    poolStore.setCurrentUserPools(Array.isArray(data) ? data : []);
                    setPollsLoaded(true);
                })
                .catch((err) => {
                    console.error("Failed to load user polls:", err);
                    setPollsLoadError("Could not load your polls. Please refresh.");
                    setPollsLoaded(true);
                });
        }
    }, [user?.user?.id]);

    const handleClick = (p) => {
       poolStore?.setSelectedPool(p);
       onPoolSelect(p);
        if (onClose) {
            onClose();
        }
    };

    const viewAllPools = () => {
        user?.setActiveComponent("AllPolls");
        if (onClose) {
            onClose();
        }
    };

    const addPool = () => {
        user?.setActiveComponent("CreatePool")
        if (onClose) {
            onClose();
        }
    };

    const isDemoMode = pollsLoaded && !pollsLoadError && poolStore?.currentUserPools?.length === 0;

    const pollsToDisplay = isDemoMode
        ? demoPolls
        : poolStore.currentUserPools.slice(0, 10);


    return (
        <div className="mt-2">
            <h5 style={{ marginBottom: '-16px' }} className="mx-auto p-2 text-muted">Your Polls</h5>
            <div style={{ marginBottom: '5px', fontSize: 'small' }} className="mx-auto p-2 text-muted">
                {!pollsLoaded
                    ? 'Loading your polls...'
                    : pollsLoadError
                        ? pollsLoadError
                        : poolStore?.currentUserPools?.length > 0
                            ? 'Last 10 poll\'s you created:'
                            : 'No poll\'s yet. Showing 5 demo examples. These will disappear once you create your first real poll.'}
            </div>

            <ListGroup key={poolStore?.currentUserPools?.length} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {pollsToDisplay.map(p => (
                    <ListGroup.Item
                        key={p.id}
                        className={`list-group-item list-group-item-action small truncated-text shadow-sm ${
                            hoveredItemId === p.id || poolStore?.selectedPool?.id === p.id ? 'list-group-item-success' : ''
                        }`}
                        style={{
                            cursor: isDemoMode ? 'not-allowed' : 'pointer',
                            borderRadius: '.25rem',
                            transition: 'transform .2s',
                            boxShadow: hoveredItemId === p.id || poolStore?.selectedPool?.id === p.id
                                ? '0px 4px 12px rgba(0, 0, 0, 0.1)' : 'none',
                            paddingTop: '0.20rem',
                            paddingBottom: '0.20rem',
                            position: 'relative',

                        }}
                        onMouseEnter={() => !isDemoMode && setHoveredItemId(p.id)}
                        onMouseLeave={() => !isDemoMode && setHoveredItemId(null)}
                        onClick={() => {
                            if (!isDemoMode) handleClick(p);
                        }}
                    >
                        <Col className="d-flex align-items-start">
            <span style={{
                marginLeft: "15px",
                marginRight: "0px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "block",
                maxWidth: "105%"
            }}>
                {p.name}
            </span>
                        </Col>

                        {p.status === 'LIVE' && (
                            <Badge bg="info" pill className="position-absolute ms-3 top-50 start-0 translate-middle">L</Badge>
                        )}
                        {p.status === 'RUNNING' && (
                            <Badge bg="warning" pill className="position-absolute text-dark ms-3 top-50 start-0 translate-middle">R</Badge>
                        )}
                        {p.status === 'COMPLETED' && (
                            <Badge
                                bg="success"
                                pill
                                className="position-absolute ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center"
                                style={{ width: '20px', height: '20px' }}
                            >
                                <i className="bi bi-check fs-5"></i>
                            </Badge>
                        )}


                    </ListGroup.Item>
                ))}


                <div className="mt-2">

                    <Row className="justify-content-center">
                        <Col xs="auto">

                                    <Button
                                        variant="outline-success"
                                        className="m-1 shadow-sm btn-sm d-flex align-items-center"
                                        onClick={addPool}
                                    >
                                        <FaPlusSquare className="me-2" />Add Poll
                                    </Button>

                        </Col>
                        <Col xs="auto">
                            <Button
                                variant="outline-success"
                                className="m-1 shadow-sm btn-sm d-flex align-items-center"
                                onClick={viewAllPools}
                            >
                                <FaThList className="me-2" />View all
                            </Button>
                        </Col>
                    </Row>
                </div>


            </ListGroup>
        </div>
    );
});

export default ColPools;
